import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import getArticleService from "../../../../services/getArticleService";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewPdf = ({ setIsOpenPdf, isOpenPdf, pdfData }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setIsOpenPdf(false);
    setPdfUrl(null);
    setLoading(true);
    setError(null);
  };

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `article_${pdfData?.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const fetchPdfUrl = async () => {
    if (pdfData?.file) {
      try {
        setLoading(true);
        setError(null);
        const response = await getArticleService.getFilePreSIgnedUrl({
          key: pdfData.file,
        });
        if (response) {
          setPdfUrl(response);
        } else {
          setError("Failed to load PDF");
        }
      } catch (error) {
        console.error("Error fetching PDF URL:", error);
        setError("Error loading PDF. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (isOpenPdf && pdfData?.file) {
      fetchPdfUrl();
    }
  }, [isOpenPdf, pdfData?.file]);

  return (
    <Dialog
      open={isOpenPdf}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullWidth={true}
      maxWidth={"lg"}
      PaperProps={{
        sx: {
          height: "90vh",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle className="pt-3 modal_header_dealog">
        View Invoice PDF
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              gap: 2,
            }}
          >
            <CircularProgress size={60} />
            <Typography variant="h6" color="text.secondary">
              Loading PDF...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please wait while we prepare your document
            </Typography>
          </Box>
        ) : error ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              gap: 2,
            }}
          >
            <Typography variant="h6" color="error">
              {error}
            </Typography>
            <Button variant="contained" color="primary" onClick={fetchPdfUrl}>
              Try Again
            </Button>
          </Box>
        ) : pdfUrl ? (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <iframe
              src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                pdfUrl
              )}&embedded=true`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              title="PDF Viewer"
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              gap: 2,
            }}
          >
            <Typography variant="h6" color="error">
              No PDF Available
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions className="pb-3">
        {pdfUrl && (
          <Button variant="contained" color="primary" onClick={handleDownload}>
            Download
          </Button>
        )}
        <Button variant="contained" color="error" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewPdf;
